<template>
  <v-container>
    <v-card class="w-full pa-2">
      <div class="d-flex flex-row justify-between" style="place-items: center">
        <div>
          <span
            v-if="[3, 4, 9, 10].includes(detail.fare_type)"
            class="f-bold f-s-xs"
            style="color: #000"
            >{{ $t("TicketMultiTrip") }}</span
          >
          <span
            v-else
            class="f-bold f-s-xs"
            style="color: #000"
            >{{ detail.fare_name }}</span
          >
        </div>
        <!-- <div class="d-flex flex-column" style="font-size: x-small">
          <span>{{ $t("UsedDate") }}:</span>
          <span>{{ detail.used_date }}</span>
        </div> -->
      </div>
      <hr />

      <div
        v-if="[3, 4, 9, 10].includes(detail.fare_type)"
        class="d-flex flex-column mt-2"
      >
        <span class="f-bold f-s-xs">{{ detail.fare_name }}</span>
      </div>
      <div v-else class="d-flex flex-row">
        <timeline-dashed :route="detail.timeline_dashed" />
      </div>
      <hr />
        
      <div>
        <span class="f-bold f-s-xs mb-1">{{ $t("TicketInformation") }}:</span>
        <div class="d-flex flex-row" style="gap: 4px;">
            <div class="d-flex flex-column">
                <span class="f-light f-s-xs">{{ $t("Time") }}</span>
                <span class="f-light f-s-xs">{{ $t("Status") }}</span>
            </div>
            <div class="d-flex flex-column">
                <span class="f-light f-s-xs">:</span>
                <span class="f-light f-s-xs">:</span>
            </div>
            <div class="d-flex flex-column" style="flex: 1;">
                <span class="f-light f-s-xs">{{ detail.used_date }}</span>
                <span class="f-light f-s-xs">{{ $t("TicketAlreadyUsed") }}</span>
            </div>
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import TimelineDashed from "@/components/TimelineDashed.vue";

export default {
    name: "TripDetail",
    components: {
        TimelineDashed
    },
    props: {
        detail: {
            type: Object,
            required: true,
        },
    }
}
</script>

<style lang="scss" scoped>
hr {
  border: none;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}
</style>